import type { HTMLAttributes } from "react";
import { Button } from "@/components/ui/button";
import type { EmptyListState } from "@/core/ui/empty-states";
import { cn } from "@/lib/utils";

export function EmptyState({
  title,
  detail,
  actionLabel,
  actionHref,
  onAction,
  className,
  ...props
}: EmptyListState &
  HTMLAttributes<HTMLDivElement> & {
    onAction?: () => void;
  }) {
  return (
    <div
      className={cn(
        "rounded-md border border-dashed border-border bg-background p-5 text-center",
        className,
      )}
      {...props}
    >
      <div className="text-sm font-semibold">{title}</div>
      <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{detail}</p>
      {onAction ? (
        <Button className="mt-4" variant="secondary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : (
        <Button asChild className="mt-4" variant="secondary">
          <a href={actionHref}>{actionLabel}</a>
        </Button>
      )}
    </div>
  );
}
